<div [style.font-size]="fontSize" class="wrapper">
  <div class="outer-circle"></div>
  <div class="inner-circle-reference">
    <div class="inner-circle"></div>
  </div>
</div>
